import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  toggle(event) {
    if (event) event.preventDefault()
    this.contentTarget.classList.toggle("hidden")
  }

  show(event) {
    if (event) event.preventDefault()
    this.contentTarget.classList.remove("hidden")
  }

  hide(event) {
    if (event) event.preventDefault()
    this.contentTarget.classList.add("hidden")
  }
}
